import React, { useEffect, useState } from "react";
import { Col, Row, Carousel } from "react-bootstrap";
import Arrow from "./svg/Arrow";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setTitle } from '../../../redux/slices/templateTitleSlice.js';
import Preload from './img/img-preload.svg';
import PreloadMob from './img/img-preload-mob.svg';

const LandingPagesBlockDesktop = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);

  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.landingPages,
  }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/entry/constructor/templates");
        const processedTemplates = response.data
          .map((template) => ({
            title: template.title,
            image:
              template.pagesSortedByPositionMeQr.length > 0
                ? template.pagesSortedByPositionMeQr[0].image
                : null,
            image2:
              template.pagesSortedByPositionMeQr.length > 1
                ? template.pagesSortedByPositionMeQr[1].image
                : null,
          }))
          .filter(
            (template) =>
              (template.image || template.image2) && template.title !== "Wi-Fi"
          );

        setTemplates(processedTemplates);

        const loadImages = processedTemplates.map(template => {
          const promises = [];
          if (template.image) {
            promises.push(new Promise((resolve) => {
              const img = new Image();
              img.src = template.image;
              img.onload = resolve;
            }));
          }
          if (template.image2) {
            promises.push(new Promise((resolve) => {
              const img = new Image();
              img.src = template.image2;
              img.onload = resolve;
            }));
          }
          return Promise.all(promises);
        });

        await Promise.all(loadImages);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  const goToTemplates = (title) => {
    dispatch(setTitle(title));
    navigate('/templates');
  };

  const generateSlides = () => {
    const slides = [];
    for (let i = 0; i < templates.length; i += 4) {
      slides.push(
        <Carousel.Item key={i}>
          <Row className="gx-3">
            {templates.slice(i, i + 4).map((template, index) => (
              <Col key={index} xs={6} lg={3}>
                <div className={`rounded-4 ${loading ? '' : 'px-4 pt-4'} landing-page-item cursor-pointer text-center`} onClick={() => goToTemplates(template.title)}>
                  {loading ? (
                    <img src={Preload} alt="Loading..." className="img-fluid" />
                  ) : (
                    <>
                      <div className="d-flex justify-content-between cursor-pointer">
                        <p className="fs-5 cursor-pointer">{template.title}</p>
                        <div className="arrowDiv">
                          <Arrow />
                        </div>
                      </div>
                      <div className="overflow-hidden position-relative h-100 cursor-pointer">
                        {template.image2 && (
                          <img
                            loading="lazy"
                            className="img-fluid cursor-pointer img-r position-absolute template-imgs"
                            src={template.image2}
                            width={130}
                            height={232}
                            alt="Landing Page Image"
                          />
                        )}
                        {template.image && (
                          <img
                            loading="lazy"
                            className="img-fluid cursor-pointer img-l position-absolute template-imgs"
                            src={template.image}
                            width={130}
                            height={232}
                            alt="Landing Page Image"
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      );
    }
    return slides;
  };

  return (
    <div className="landing-pages-carousel">
      <h2 className="mb-4">{lang[0]}</h2>
      <Carousel interval={null}>
        {generateSlides()}
      </Carousel>
    </div>
  );
};

const LandingPagesBlockMobile = () => {
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);

  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.landingPages,
  }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/entry/constructor/templates");
        const processedTemplates = response.data.map((template) => ({
          title: template.title,
          image:
            template.pagesSortedByPositionMeQr.length > 0
              ? template.pagesSortedByPositionMeQr[0].image
              : null,
        }));

        setTemplates(processedTemplates);


        const loadImages = processedTemplates.map(template => {
          if (template.image) {
            return new Promise((resolve) => {
              const img = new Image();
              img.src = template.image;
              img.onload = resolve;
            });
          }
          return Promise.resolve();
        });

        await Promise.all(loadImages);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToTemplates = (title) => {
    dispatch(setTitle(title));
    navigate('/templates');
  };

  const generateSlides = () => {
    return templates.map((template, index) => (
      <Col key={index} xs={6}>
        <div className="bg-white border rounded-3 text-center position-relative overflow-hidden" style={{ height: "266px" }} onClick={() => goToTemplates(template.title)}>
          {loading ? (
            <img src={PreloadMob} alt="Loading..." className="img-fluid" />
          ) : (
            <>
              <div className="d-flex justify-content-between px-3 pt-3">
                <p className="">{template.title}</p>
                <div className="arrowDiv">
                  <Arrow />
                </div>
              </div>
              {template.image && (
                <img
                  loading="lazy"
                  className="img-fluid position-absolute translate-middle-x start-50 top-5 rounded-4 border-4 border"
                  src={template.image}
                  width={136}
                  height={208}
                  alt="Landing Page Image"
                />
              )}
            </>
          )}
        </div>
      </Col>
    ));
  };

  return (
    <div className="mb-5">
      <h2 className="fs-5 text-center mb-4">{lang[0]}</h2>
      <Row className="g-3">
        {generateSlides().slice(0, 4)}
      </Row>
      <div className="col-6 mx-auto mt-5 pb-4">
        <button onClick={() => goToTemplates()} className="btn btn-primary w-100">
          {lang[1]}
        </button>
      </div>
    </div>
  );
};

export { LandingPagesBlockDesktop, LandingPagesBlockMobile };
